/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterNoticeDto } from '../../models/center-notice-dto';

export interface CenterNoticeControllerDelete$Params {
  id: string;
}

export function centerNoticeControllerDelete(http: HttpClient, rootUrl: string, params: CenterNoticeControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterNoticeDto>> {
  const rb = new RequestBuilder(rootUrl, centerNoticeControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CenterNoticeDto>;
    })
  );
}

centerNoticeControllerDelete.PATH = '/api/center-notice/center/{id}';
